import React, { useState, useEffect } from 'react';
import {
   Box,
   Flex,
   FormControl,
   FormLabel,
   Grid,
   Input,
   InputGroup,
   Switch,
   Text,
   Textarea,
   VStack,
   useColorModeValue,
} from '@chakra-ui/react';
import Select from 'react-select';
import { SearchIcon } from '@chakra-ui/icons';
import { useDispatch, useSelector } from 'react-redux';

export const renderFormControl = (
   name,
   label,
   props,
   errors = {},
   textColor = 'gray.700',
   inputType,
   isRequired = false,
   isDisabled = false,
) => {
   return (
      <FormControl mb="24px">
         <Flex alignItems="center">
            <FormLabel
               htmlFor={name}
               mb={0}
               flexShrink={0}
               width="50%"
               fontSize="sm"
               fontWeight="500"
               color={textColor}>
               {label}
               {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
            </FormLabel>
            <Input
               id={name}
               isRequired={isRequired}
               variant="auth"
               fontSize="sm"
               name={name}
               placeholder={`Enter ${label}`}
               size="lg"
               type={inputType}
               isDisabled={isDisabled}
               {...props}
            />
         </Flex>
         {errors[name] && (
            <Text color="red.500" fontSize="sm" mt="2">
               {errors[name]}
            </Text>
         )}
      </FormControl>
   );
};

// export const renderFormControl = (
//   name,
//   label ,
//   props,
//   errors = {},
//   textColor= 'gray.700',
//   inputType,
//   isRequired = false,
//   isDisabled = false
// ) => {
//   return (
//     <FormControl
//       mb="24px"
//     >
//       <FormLabel
//         display="flex"
//         ms="4px"
//         fontSize="sm"
//         fontWeight="500"
//         color={textColor}
//       >
//         {label}
//         {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
//       </FormLabel>

//       <InputGroup size="md">
//         <Input
//           isRequired={isRequired}
//           variant="auth"
//           fontSize="sm"
//           name={name}
//           placeholder={`Enter ${label}`}
//           size="lg"
//           type={inputType}
//           isDisabled={isDisabled}
//           {...props}
//         />
//       </InputGroup>
//       {errors[name] && (
//         <Text color="red.500" fontSize="sm" mt="2">
//           {errors[name]}
//         </Text>
//       )}
//     </FormControl>
//   );
// };

// export const renderSelectFormControl = (
//   name,
//   label,
//   options,
//   props,
//   errors = {},
//   textColor = 'gray.700',
//   isRequired = false,
//   placeholder = "Select an option"
// ) => {
//   return (
//     <FormControl
//       mb="24px"
//       isInvalid={!!errors[name]}
//     >
//       <FormLabel
//         display="flex"
//         ms="4px"
//         fontSize="sm"
//         fontWeight="500"
//         color={textColor}
//       >
//         {label}
//         {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
//       </FormLabel>

//       <InputGroup size="md">
//         <Select
//           isRequired={isRequired}
//           variant="auth"
//           fontSize="sm"
//           name={name}
//           placeholder={placeholder}
//           size="lg"
//           {...props}
//         >
//           {options.map((option) => (
//             <option
//               key={option.id}
//               value={option.id}
//             >
//               {option.name}
//             </option>
//           ))}
//         </Select>
//       </InputGroup>
//       {errors[name] && (
//         <Text color="red.500" fontSize="sm" mt="2">
//           {errors[name]}
//         </Text>
//       )}
//     </FormControl>
//   );
// };

// Helper function to get nested errors
// const getNestedError = (errors, name) => {
//   if (!errors) return null;

//   // Handle nested paths like 'header.daybookId'
//   const paths = name.split('.');
//   let current = errors;

//   for (const path of paths) {
//     if (!current || !current[path]) return null;
//     current = current[path];
//   }

//   return current;
// };

const getNestedError = (errors, name) => {
   return name.split('.').reduce((acc, part) => (acc && acc[part] ? acc[part] : null), errors);
};

const SelectFormControl = ({
   name,
   label,
   isMulti = false,
   options = [],
   value,
   errors = {},
   textColor = 'gray.700',
   isRequired = false,
   placeholder = 'Select an option',
   ...props
}) => {
   const [selectedOption, setSelectedOption] = useState(null);

   const errorMessage = getNestedError(errors, name);
   // useEffect(() => {
   //   if (value || value === 0) {
   //     const option = options?.find((opt) => {
   //       return opt.id?.toString() === value?.toString();
   //     });
   //     if (option) {
   //       setSelectedOption({ value: option.id, label: option.name });
   //     }
   //   }
   // }, [value, options, name]);

   useEffect(() => {
      if (value || value === 0) {
         const option = options?.find((opt) => opt.id?.toString() === value?.toString());
         if (option) {
            setSelectedOption({ value: option.id, label: option.name });
         } else {
            setSelectedOption(null); // Reset if value is not in options
         }
      } else {
         setSelectedOption(null); // Ensure placeholder appears on clear
      }
   }, [value, options]);

   // useEffect(() => {
   //   if (props.value) {
   //     const option = options.find(
   //       (opt) => opt.id?.toString() === props.value?.toString(),
   //     );
   //     if (option) {
   //       setSelectedOption({ value: option.id, label: option.name });
   //     }
   //   }
   // }, [value, options]);

   // const handleChange = (selected) => {
   //   setSelectedOption(selected);
   //   let values;
   //   if (isMulti) {
   //     values = selected.map((option) => option.value);
   //   } else {
   //     values = selected.value;
   //   }
   //   props.onChange(values);
   //   // props.onChange?.({ target: { name, value: selected?.value } });
   //   // props.onChange?.(selected);
   // };

   const handleChange = (selected) => {
      if (!selected) {
         setSelectedOption(null); // Ensure placeholder appears
         props.onChange(null); // Send null value when cleared
         return;
      }

      setSelectedOption(selected);
      let values = isMulti ? selected.map((option) => option.value) : selected.value;
      props.onChange(values);
   };

   return (
      <FormControl mb="24px" isInvalid={!!errorMessage}>
         <Flex alignItems="center">
            <FormLabel
               htmlFor={name}
               mb={0}
               flexShrink={0}
               width="50%"
               fontSize="sm"
               fontWeight="500"
               color={textColor}>
               {label}
               {isRequired && (
                  <Text as="span" color="red.500">
                     *
                  </Text>
               )}
            </FormLabel>
            <Box width="100%">
               <Select
                  id={name}
                  options={
                     Array.isArray(options)
                        ? options.map((opt) => ({
                             value: opt.id,
                             label: opt.name,
                          }))
                        : []
                  }
                  isSearchable
                  isClearable
                  value={selectedOption}
                  onChange={handleChange}
                  isMulti={isMulti}
                  // options={options.map((opt) => ({ value: opt.id, label: opt.name }))}
                  placeholder={placeholder}
                  menuPlacement="auto"
                  styles={{
                     menu: (provided) => ({
                        ...provided,
                        width: '270px', // Ensure dropdown width matches
                        left: '50%', // Position dropdown box
                        transform: 'translateX(-50%)', // Center align
                        zIndex: 1000,
                     }),
                  }}
                  // isClearable
                  // isSearchable={true}
                  // filterOption={customFilterOption}
                  // styles={{
                  //   control: (provided) => ({
                  //     ...provided,
                  //     borderColor: errorMessage ? 'red' : provided.borderColor,
                  //   }),
                  //   menu: (provided) => ({
                  //     ...provided,
                  //     zIndex: 9999,
                  //   }),
                  // }}
               />
            </Box>
         </Flex>

         {errorMessage && (
            <Text color="red.500" fontSize="sm" mt="2">
               {errorMessage}
            </Text>
         )}
      </FormControl>
   );
};

// Wrapper function to maintain the existing API
export const renderSelectFormControl = (
   name,
   label,
   options,
   props,
   errors = {},
   textColor = 'gray.700',
   isRequired = false,
   placeholder = 'Select an option',
   isSearchable = false,
   filteredOptions,
) => {
   return (
      <SelectFormControl
         name={name}
         label={label}
         options={options}
         value={props.value}
         errors={errors}
         textColor={textColor}
         isRequired={isRequired}
         placeholder={placeholder}
         isSearchable={isSearchable}
         filteredOptions={filteredOptions}
         {...props}
      />
   );
};

// const SelectFormControl = ({
//   name,
//   label,
//   options,
//   errors = {},
//   textColor = 'gray.700',
//   isRequired = false,
//   placeholder = "Select an option",
//   isSearchable = false,
//   ...props
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [filteredOptions, setFilteredOptions] = useState(options);

//   // Get error message considering nested structure
//   const errorMessage = getNestedError(errors, name);

//   useEffect(() => {
//     if (isSearchable) {
//       const filtered = options.filter(option =>
//         option.name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredOptions(filtered);
//     }
//   }, [searchTerm, options, isSearchable]);

//   useEffect(() => {
//     if (props.value) {
//       const option = options.find(opt => opt.id?.toString() === props.value?.toString());
//       if (option) {
//         setSelectedOption(option);
//         setSearchTerm(option.name);
//       }
//     }
//   }, [props.value, options]);

//   const handleSelect = (option) => {
//     setSelectedOption(option);
//     setSearchTerm(option.name);
//     setIsOpen(false);
//     if (props.onChange) {
//       props.onChange({ target: { name, value: option.id } });
//     }
//   };

//   return (
//     <FormControl
//       mb="24px"
//       isInvalid={!!errorMessage}
//     >
//       <FormLabel
//         display="flex"
//         ms="4px"
//         fontSize="sm"
//         fontWeight="500"
//         color={textColor}
//       >
//         {label}
//         {isRequired && <Text color="red.500" ml="1">*</Text>}
//       </FormLabel>

//       <InputGroup size="md" position="relative">
//         {isSearchable ? (
//           <Box position="relative" width="100%">
//             <Input
//               value={searchTerm}
//               onChange={(e) => {
//                 setSearchTerm(e.target.value);
//                 setIsOpen(true);
//               }}
//               onFocus={() => setIsOpen(true)}
//               onBlur={() => {
//                 setTimeout(() => setIsOpen(false), 200);
//               }}
//               placeholder={placeholder}
//               isRequired={isRequired}
//               variant="auth"
//               fontSize="sm"
//               size="lg"
//               pr="40px"
//               isInvalid={!!errorMessage}
//               {...props}
//             />
//             <Box
//               position="absolute"
//               right="3"
//               top="50%"
//               transform="translateY(-50%)"
//               color="gray.500"
//               pointerEvents="none"
//             >
//               <SearchIcon w="18px" h="18px" />
//             </Box>

//             {isOpen && (
//               <Box
//                 position="absolute"
//                 zIndex={10}
//                 width="100%"
//                 mt="1"
//                 bg="white"
//                 border="1px"
//                 borderColor="gray.200"
//                 borderRadius="md"
//                 boxShadow="sm"
//                 maxH="60"
//                 overflow="auto"
//               >
//                 <VStack align="stretch" spacing={0}>
//                   {filteredOptions.length > 0 ? (
//                     filteredOptions.map((option) => (
//                       <Box
//                         key={option.id}
//                         px="4"
//                         py="2"
//                         cursor="pointer"
//                         fontSize="sm"
//                         onClick={() => handleSelect(option)}
//                         _hover={{ bg: 'gray.50' }}
//                         transition="background 0.2s"
//                       >
//                         {option.name}
//                       </Box>
//                     ))
//                   ) : (
//                     <Box px="4" py="2" fontSize="sm" color="gray.500">
//                       No options found
//                     </Box>
//                   )}
//                 </VStack>
//               </Box>
//             )}
//           </Box>
//         ) : (
//           <Select
//             isRequired={isRequired}
//             variant="auth"
//             fontSize="sm"
//             name={name}
//             placeholder={placeholder}
//             size="lg"
//             isInvalid={!!errorMessage}
//             {...props}
//           >
//             {options?.map((option) => (
//               <option
//                 key={option.id}
//                 value={option.id}
//               >
//                 {option.name}
//               </option>
//             ))}
//           </Select>
//         )}
//       </InputGroup>

//       {errorMessage && (
//         <Text color="red.500" fontSize="sm" mt="2">
//           {errorMessage}
//         </Text>
//       )}
//     </FormControl>
//   );
// };

// // Wrapper function to maintain the existing API
// export const renderSelectFormControl = (
//   name,
//   label,
//   options,
//   props,
//   errors = {},
//   textColor = 'gray.700',
//   isRequired = false,
//   placeholder = "Select an option",
//   isSearchable = false
// ) => {
//   return (
//     <SelectFormControl
//       name={name}
//       label={label}
//       options={options}
//       errors={errors}
//       textColor={textColor}
//       isRequired={isRequired}
//       placeholder={placeholder}
//       isSearchable={isSearchable}
//       {...props}
//     />
//   );
// };

// Component version of the select control
// const SelectFormControl = ({
//   name,
//   label,
//   options,
//   errors = {},
//   textColor = 'gray.700',
//   isRequired = false,
//   placeholder = "Select an option",
//   isSearchable = false,
//   ...props
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [filteredOptions, setFilteredOptions] = useState(options);

//   useEffect(() => {
//     if (isSearchable) {
//       const filtered = options.filter(option =>
//         option.name.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredOptions(filtered);
//     }
//   }, [searchTerm, options, isSearchable]);

//   useEffect(() => {
//     if (props.value) {
//       const option = options.find(opt => opt.id === props.value);
//       if (option) {
//         setSelectedOption(option);
//         setSearchTerm(option.name);
//       }
//     }
//   }, [props.value, options]);

//   const handleSelect = (option) => {
//     setSelectedOption(option);
//     setSearchTerm(option.name);
//     setIsOpen(false);
//     if (props.onChange) {
//       props.onChange({ target: { name, value: option.id } });
//     }
//   };

//   return (
//     <FormControl
//       mb="24px"
//       isInvalid={!!errors[name]}
//     >
//       <FormLabel
//         display="flex"
//         ms="4px"
//         fontSize="sm"
//         fontWeight="500"
//         color={textColor}
//       >
//         {label}
//         {isRequired && <Text color="red.500" ml="1">*</Text>}
//       </FormLabel>

//       <InputGroup size="md" position="relative">
//         {isSearchable ? (
//           <Box position="relative" width="100%">
//             <Input
//               value={searchTerm}
//               onChange={(e) => {
//                 setSearchTerm(e.target.value);
//                 setIsOpen(true);
//               }}
//               onFocus={() => setIsOpen(true)}
//               onBlur={() => {
//                 setTimeout(() => setIsOpen(false), 200);
//               }}
//               placeholder={placeholder}
//               isRequired={isRequired}
//               variant="auth"
//               fontSize="sm"
//               size="lg"
//               pr="40px"
//               {...props}
//             />
//             <Box
//               position="absolute"
//               right="3"
//               top="50%"
//               transform="translateY(-50%)"
//               color="gray.500"
//               pointerEvents="none"
//             >
//               <SearchIcon w="18px" h="18px" />
//             </Box>

//             {isOpen && (
//               <Box
//                 position="absolute"
//                 zIndex={10}
//                 width="100%"
//                 mt="1"
//                 bg="white"
//                 border="1px"
//                 borderColor="gray.200"
//                 borderRadius="md"
//                 boxShadow="sm"
//                 maxH="60"
//                 overflow="auto"
//               >
//                 <VStack align="stretch" spacing={0}>
//                   {filteredOptions.length > 0 ? (
//                     filteredOptions.map((option) => (
//                       <Box
//                         key={option.id}
//                         px="4"
//                         py="2"
//                         cursor="pointer"
//                         fontSize="sm"
//                         onClick={() => handleSelect(option)}
//                         _hover={{ bg: 'gray.50' }}
//                         transition="background 0.2s"
//                       >
//                         {option.name}
//                       </Box>
//                     ))
//                   ) : (
//                     <Box px="4" py="2" fontSize="sm" color="gray.500">
//                       No options found
//                     </Box>
//                   )}
//                 </VStack>
//               </Box>
//             )}
//           </Box>
//         ) : (
//           <Select
//             isRequired={isRequired}
//             variant="auth"
//             fontSize="sm"
//             name={name}
//             placeholder={placeholder}
//             size="lg"
//             {...props}
//           >
//             {options.map((option) => (
//               <option
//                 key={option.id}
//                 value={option.id}
//               >
//                 {option.name}
//               </option>
//             ))}
//           </Select>
//         )}
//       </InputGroup>

//       {errors[name] && (
//         <Text color="red.500" fontSize="sm" mt="2">
//           {errors[name]}
//         </Text>
//       )}
//     </FormControl>
//   );
// };

// // Wrapper function to maintain the existing API
// export const renderSelectFormControl = (
//   name,
//   label,
//   options,
//   props,
//   errors = {},
//   textColor = 'gray.700',
//   isRequired = false,
//   placeholder = "Select an option",
//   isSearchable = false
// ) => {
//   return (
//     <SelectFormControl
//       name={name}
//       label={label}
//       options={options}
//       errors={errors}
//       textColor={textColor}
//       isRequired={isRequired}
//       placeholder={placeholder}
//       isSearchable={isSearchable}
//       {...props}
//     />
//   );
// };

// export const renderSideFormControl = (
//   name,
//   label,
//   props,
//   errors = {},
//   textColor = 'gray.700',
//   inputType,
//   isRequired = false,
//   isDisabled = false
// ) => {
//   return (
//     <FormControl mb="24px">
//       <span style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
//         <span
//           style={{
//             fontSize: "sm",
//             fontWeight: "500",
//             color: textColor,
//             marginRight: "8px", // Space between label and input
//           }}
//         >
//           {label}
//           {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
//         </span>

//         <InputGroup size="md">
//           <Input
//             isRequired={isRequired}
//             variant="auth"
//             fontSize="sm"
//             name={name}
//             id={name}
//             placeholder={`Enter ${label}`}
//             size="lg"
//             type={inputType}
//             isDisabled={isDisabled}
//             {...props}
//           />
//         </InputGroup>
//       </span>

//       {errors[name] && (
//         <Text color="red.500" fontSize="sm" mt="2">
//           {errors[name]}
//         </Text>
//       )}
//     </FormControl>
//   );
// };

export const renderSideFormControl = (name, props, errors = {}, isRequired = false, isDisabled = false) => {
   return (
      <Input
         isRequired={isRequired}
         variant="auth"
         fontSize="sm"
         name={name}
         id={name}
         size="lg"
         type={props.type || 'text'} // default to 'text' if no type is provided
         isDisabled={isDisabled}
         placeholder={props.placeholder || 'Enter value'}
         {...props} // spread any other props passed in
      />
   );
};

export const renderSwitchControl = (
   name,
   label,
   props,
   errors = {},
   textColor = 'gray.700',
   isRequired = false,
   isDisabled = false,
) => {
   return (
      <FormControl>
         <Flex
            alignItems="center"
            border="1px solid"
            borderColor="gray.300"
            px={3}
            py={2}
            borderRadius="8px"
            _hover={{
               boxShadow: '0px 0px 15px rgba(0, 60, 140, 0.3)',
               border: '0px', // Corrected syntax
            }}>
            <FormLabel
               htmlFor={name}
               mb={0}
               flexShrink={0}
               width="60%"
               fontSize="sm"
               fontWeight="500"
               color={textColor}>
               {label}
               {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
            </FormLabel>

            {/* Switch component */}
            <Switch
               id={name}
               name={name}
               size="lg" // Larger size for consistency
               isDisabled={isDisabled}
               {...props}
               ml="20%"
            />
         </Flex>
         {/* Error message */}
         {errors[name] && (
            <Text color="red.500" fontSize="sm" mt="2">
               {errors[name]}
            </Text>
         )}
      </FormControl>
   );
   // return(
   //   <FormControl mb="24px">
   //     <Flex
   //       alignItems="center"
   //       border="1px solid"
   //       borderColor="gray.300"
   //       p={3}
   //       borderRadius="10px"
   //       _hover={{
   //         boxShadow: "0px 0px 15px rgba(0, 60, 140, 0.3)",
   //         border: "0px", // Corrected syntax
   //       }}
   //     >
   //       <FormLabel
   //         htmlFor={name}
   //         mb={0}
   //         flexShrink={0}
   //         width="200px"
   //         fontSize="sm"
   //         fontWeight="500"
   //         color={textColor}
   //       >
   //         {label}
   //         {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
   //       </FormLabel>

   //       {/* Switch component */}
   //       <Switch
   //         id={name}
   //         name={name}
   //         size="lg" // Larger size for consistency
   //         isDisabled={isDisabled}
   //         {...props}
   //         ml="120px"
   //       />
   //     </Flex>

   //     {/* Error message */}
   //     {errors[name] && (
   //       <Text color="red.500" fontSize="sm" mt="2">
   //         {errors[name]}
   //       </Text>
   //     )}
   //   </FormControl>
   // );
};

export const renderTextareaControl = (
   name,
   label,
   props,
   errors = {},
   textColor = 'gray.700',
   isRequired = false,
   isDisabled = false,
) => {
   return (
      <FormControl mb="24px">
         <Flex alignItems="center">
            <FormLabel
               htmlFor={name}
               mb={0}
               flexShrink={0}
               width="100px"
               fontSize="sm"
               fontWeight="500"
               color={textColor}>
               {label}
               {isRequired && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
            </FormLabel>
            <Textarea
               id={name}
               isRequired={isRequired}
               variant="auth"
               fontSize="sm"
               name={name}
               placeholder={`Enter ${label}`}
               size="lg"
               borderRadius="12px"
               border="1px solid"
               borderColor="gray.300"
               isDisabled={isDisabled}
               {...props}
            />
         </Flex>
         {errors[name] && (
            <Text color="red.500" fontSize="sm" mt="2">
               {errors[name]}
            </Text>
         )}
      </FormControl>
   );
};
